import  { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://api.axionnest.com";
export const LeftColumn = () => {
  const navigate=useNavigate()
  const [profile, setProfile] = useState(null);

  const token = localStorage.getItem("access_token");
  useEffect(() => {

    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : "",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        if (!res.ok) {
          console.error("Failed to fetch profile:", res.status);
          return;
        }

        const data = await res.json();
        setProfile(data?.data || null);
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };

    fetchProfile();
  }, []);

  // useEffect(() => {
  //   const fetchVisibility = async () => {
  //     try {

  //       const res = await fetch(`${BASE_URL}/user/profile/visibility/`, {
  //         method: "GET",
  //         headers: {
  //           Accept: "application/json",
  //           Authorization: token ? `Bearer ${token}` : "",
  //         },
  //       });
  //       if (!res.ok) {
  //         console.error("Failed to fetch visibilty:", res.status);
  //         return;
  //       }
  //       const data = await res.json();
  //       setVisibility(data?.data || null);
  //     } catch (err) {
  //       console.error("Error fetching visibility:", err);

  //     }
  //   }
  // })
  return (
    // <aside className="left-col">
    //   {/* Profile Card */}
    //   <section className="card profile-card">
    //     <div className="profile-head">
    //       <img
    //         className="profile-avatar"
    //         src={
    //           profile?.profile_picture || "https://via.placeholder.com/44"
    //         }
    //         alt="Profile"
    //       />
    //       <div className="profile-info">
    //         <h4>{profile?.name || "null"}</h4>
    //         <div className="profile-role">
    //           {profile?.degree || "null"}
    //         </div>
    //         <div className="profile-meta">
    //           {profile?.institution || "null"}
    //         </div>
    //       </div>
    //     </div>


    //     <div className="section-block">
    //       <div className="left-col-section-label">Primary Affiliation</div>
    //       <div className="focus-line">
    //         {profile?.primary_affiliation || "null"}
    //       </div>
    //     </div>

    //     <div className="section-block">
    //       <div className="left-col-section-label">Current Activity</div>
    //       <div className="focus-line">
    //         {profile?.current_activity || "null"}
    //       </div>
    //     </div>

    //     <div className="section-block">
    //       <div className="left-col-section-label">Domains</div>
    //       <div className="chips-row">
    //         {profile?.research_areas || "null"}
    //       </div>
    //     </div>
    //   </section>
     
    // </aside>
  <aside className="flex flex-col gap-4 flex-1 w-full">
  {/* Profile Card */}
  <section className="w-full rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition-all duration-200 hover:shadow-md hover:border-gray-300">
    {/* Profile Header */}
    <div className="flex items-start gap-4 mb-6">
      <div className="relative cursor-pointer">
        <img
          className="
            w-16 h-16
            rounded-xl
            object-cover
            border-2 border-white
            shadow-md
          "
          src={profile?.profile_picture || "https://via.placeholder.com/64"}
          alt="Profile"
          onClick={()=>navigate("/profile-view")}
        />
        <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white"></div>
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between">
          <div>
            <h4 className="
              text-lg font-semibold text-gray-900
              truncate
            ">
              {profile?.name || "No name provided"}
            </h4>
            
            <div className="flex items-center gap-2 mt-1">
              <span className="
                text-sm font-medium
                px-2.5 py-1
                rounded-lg
                bg-[#e8f0f7]
                text-[#0f6abf]
              ">
                {profile?.degree || "Student"}
              </span>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-500 mt-2 truncate">
          {profile?.institution || "No institution specified"}
        </p>
      </div>
    </div>

    {/* Primary Affiliation */}
    <div className="border-t border-gray-100 pt-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <div className="text-sm font-semibold text-gray-700">
          Primary Affiliation
        </div>
      </div>
      <div className="text-sm text-gray-900 bg-gray-50 rounded-xl p-3">
        {profile?.primary_affiliation || "Not specified"}
      </div>
    </div>

    {/* Current Activity */}
    <div className="border-t border-gray-100 pt-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <div className="text-sm font-semibold text-gray-700">
          Current Activity
        </div>
      </div>
      <div className="text-sm text-gray-900 bg-gray-50 rounded-xl p-3">
        {profile?.current_activity || "No current activity"}
      </div>
    </div>

    {/* Domains */}
    <div className="border-t border-gray-100 pt-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <div className="text-sm font-semibold text-gray-700">
          Research Domains
        </div>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {profile?.research_areas ? (
          profile.research_areas.split(',').map((domain, index) => (
            <span
              key={index}
              className="
                text-xs font-medium
                px-3 py-1.5
                rounded-lg
                bg-[#e8f0f7]
                text-[#0f6abf]
                hover:bg-[#d0e0f0]
                transition-colors
                truncate
                max-w-full
              "
              title={domain.trim()}
            >
              {domain.trim()}
            </span>
          ))
        ) : (
          <div className="text-sm text-gray-400 italic py-2">
            No research domains specified
          </div>
        )}
      </div>
    </div>

    {/* Additional Info */}
    {profile?.email && (
      <div className="border-t border-gray-100 pt-5">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <div className="text-sm font-semibold text-gray-700">
            Contact
          </div>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89-4.26a2 2 0 012.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <span className="truncate">{profile.email}</span>
        </div>
      </div>
    )}

    {/* Important links styled as a left-side popup card (not footer) */}
    <div className="mt-5">
      <div className="p-4 rounded-2xl border border-gray-200 shadow-lg hover:shadow-xl transition-all duration-200">
        <div className="mb-3 text-xs font-semibold uppercase tracking-wider text-gray-500">
          Explore
        </div>
        <ul className="space-y-2">
          {[
            { label: "About Us", href: "/about" },
            { label: "Contact Us", href: "/contact" },
            { label: "Blogs", href: "/blogs" },
            { label: "Careers", href: "/careers" },
            { label: "Privacy Policy", href: "/privacy" },
            { label: "Terms of Service", href: "/terms" },
            { label: "Help Center", href: "/help" },
          ].map((link) => (
            <li key={link.href}>
              <button
                type="button"
                onClick={() => navigate(link.href)}
                className="flex items-center justify-between w-full px-3 py-2 rounded-lg bg-[#e8f0f7] hover:bg-blue-200 text-blue-700 font-semibold transition-all duration-200"
              >
                <span>{link.label}</span>
                <FaArrowRight className="text-blue-500 text-sm" />
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
</aside>

  );
};
